import * as config from "./config"

// 商品发布
export const product_release = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/v2/api/goods/save'

//获取商品版块列表
export const GetlistProductSections = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/productPlate/list'
// 商品编辑
export const product_update = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/v2/api/goods/update'

//获取软件平台商品分类
export const getClassificationofgoods = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/goods/software/category/list'

//商品规格生成
export const ProductSpecificationGeneration = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/v2/api/goods/specifica/add'
